import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { CREATE_DEPT_PROJECT_PERMISSION_PREFIX_URL } from './constants/config.create-dept-project-permission'

const ListPage = lazy(
  () => import('./pages/ListPage.CreateDeptProjectPermission')
)

const CreateDeptProjectPermissionRouters: AppRouterItem[] = [
  {
    path: `${CREATE_DEPT_PROJECT_PERMISSION_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default CreateDeptProjectPermissionRouters
